import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import {
  CollectionBase,
  CriticalStandard,
  Newsletter,
  Podcast,
  Report,
  Video,
} from '@/domain/types/collections';
import useGetDocument from '@/domain/use-cases/get-document';
import AlertMessage from '@/presentation/components/alert-message';
import CommentsDetailDocument from '@/presentation/components/detail-document/comments';
import HeaderDetailDocument from '@/presentation/components/detail-document/header';
import StatsDetailDocument from '@/presentation/components/detail-document/stats';
import FormAddDocument from '@/presentation/components/form-add-document';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const VideoDetailsPage = () => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data,
    error,
    isLoading,
    updateDocument,
    deleteDocument,
    deleteComment,
    comments,
  } = useGetDocument<Video>(DOCUMENTS_DB.VIDEOS, id);

  const handleDelete = async () => {
    try {
      await deleteDocument();
      toast.success('Video eliminado correctamente', { theme: 'colored' });
      navigate('/dashboard/videos');
    } catch (error) {
      console.log(error);
      toast.error('Error al eliminar el video', { theme: 'colored' });
    }
  };

  const handleSave = async (
    updateData:
      | CollectionBase
      | Video
      | Newsletter
      | Report
      | CriticalStandard
      | Podcast,
  ) => {
    try {
      const updatedData = { ...data, ...updateData };
      console.log(updatedData);
      await updateDocument(updatedData);
      toast.success('Video actualizado correctamente', { theme: 'colored' });
    } catch (error) {
      console.log(error);
      toast.error('Error al actualizar el video', { theme: 'colored' });
    }
  };

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No data</div>;

  return (
    <div className="p-4 flex flex-row md:flex-col gap-8">
      <HeaderDetailDocument
        title={data.title}
        handleDelete={() => setIsAlertMessageOpen(true)}
      />

      <StatsDetailDocument data={data} />

      <FormAddDocument
        onSave={handleSave}
        document={data}
        hasAudio={false}
        hasImage={false}
        hasPdf={false}
        hasVideo={true}
        contentType="video"
      />

      <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
        <CommentsDetailDocument data={comments} deleteComment={deleteComment} />
      </div>

      <AlertMessage
        title="Eliminar Video"
        message="¿Estás seguro de querer eliminar este video?"
        onConfirm={handleDelete}
        onCancel={() => setIsAlertMessageOpen(false)}
        isOpen={isAlertMessageOpen}
      />
    </div>
  );
};

export default VideoDetailsPage;
